function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.760337144,7.9995 C0.0843371444,7.9995 -0.254662856,8.7555 0.224337144,9.1995 L4.46333714,14.7935 C4.75933714,15.0675 5.24033714,15.0675 5.53633714,14.7935 L9.77633714,9.1995 C10.2543371,8.7555 9.91533714,7.9995 9.23933714,7.9995 L0.760337144,7.9995 Z M0.760337144,6.9995 C0.0843371444,6.9995 -0.254662856,6.2435 0.224337144,5.7995 L4.46333714,0.2055 C4.75933714,-0.0685 5.24033714,-0.0685 5.53633714,0.2055 L9.77633714,5.7995 C10.2543371,6.2435 9.91533714,6.9995 9.23933714,6.9995 L0.760337144,6.9995 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-5 -3 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/dropdown.811ee719.svg";
export { SvgComponent as ReactComponent };